import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { useState } from "react";

const BrowserDefaultForm = () => {
  // Define a single state object to store all input values
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    variety: "",
    quantity: 0,
  });

  const handleInputChange = (fieldName: string, value: string | number) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    // Access the form data from the state
    console.log(formData);
    // Perform other actions, such as sending data to a server
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="g-3">
        <Col xs={12}>
          <Label htmlFor="name"> {"Name"}</Label>
          <Input
            type="text"
            placeholder="Name"
            value={formData.name}
            onChange={(e) => handleInputChange("name", e.target.value)}
            required
          />
        </Col>
        <Col xs={12}>
          <Label>{"Phone Number"}</Label>
          <Input
            type="text"
            placeholder="+1 2332 2223"
            value={formData.number}
            onChange={(e) => handleInputChange("number", e.target.value)}
            required
          />
        </Col>

        <Col xs={12}>
          <Label htmlFor="Variety">Variety</Label>
          <Input
            type="text"
            placeholder="Variety"
            value={formData.variety}
            onChange={(e) => handleInputChange("variety", e.target.value)}
            required
          />
        </Col>

        <Col xs={12}>
          <Label htmlFor="quantity">Quantity</Label>
          <Input
            type="number"
            placeholder="quantity"
            value={formData.quantity}
            onChange={(e) => handleInputChange("quantity", e.target.value)}
            required
          />
        </Col>
        <Col xs={12}>
          <Button color="primary" type="submit">
            Submit
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default BrowserDefaultForm;
